export default __webpack_public_path__ + "static/media/updown-graph.936321c0.png";